import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
export default function RootLayout() {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    return (_jsxs("div", { className: "min-h-screen bg-gray-50", children: [_jsx(Header, { onMenuToggle: () => setIsSidebarCollapsed(!isSidebarCollapsed), showMenuButton: true }), _jsx(Sidebar, { collapsed: isSidebarCollapsed }), _jsx("main", { className: `
          pt-16 
          transition-all 
          duration-300
          ${isSidebarCollapsed ? 'md:ml-16' : 'md:ml-64'}
        `, children: _jsx("div", { className: "mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8", children: _jsx(Outlet, {}) }) })] }));
}
